import { render, staticRenderFns } from "./FeedbackQuestion.vue?vue&type=template&id=be73ad4c"
import script from "./FeedbackQuestion.vue?vue&type=script&lang=js"
export * from "./FeedbackQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports